import { FC } from 'react';
import { useSelector } from 'react-redux';

import clsx from 'clsx';
import { RoomPlace } from 'src/components/RoomPlace/RoomPlace';
import { getAdminState } from 'src/store/admin/selectors';
import { Room } from 'src/types';

import classes from './AdministratorRoomPlace.module.scss';

export interface AdministratorRoomPlaceProps {
  item: Room;
}

export const AdministratorRoomPlace: FC<AdministratorRoomPlaceProps> = ({
  item,
}) => {
  const { selectedPlace, ghost } = useSelector(getAdminState);

  const active = selectedPlace?.mapPlaceId === item.mapPlaceId;

  const disabled = ghost?.mapPlaceId === item.mapPlaceId;

  return (
    <RoomPlace
      item={item}
      className={clsx(classes.room, active && classes.roomActive)}
      contentClassName={clsx(classes.title, active && classes.titleActive)}
      disabled={disabled}
    />
  );
};
